export interface HealthCheckItem {
  id: string
  label: string
  ok: boolean
  details: string
  fixAction?: string
}

export interface HealthReportResponse {
  ok: boolean
  summary: { ok: boolean; total: number; passed: number }
  checks: HealthCheckItem[]
  detectedAgents: Array<'claude' | 'cursor' | 'codex'>
}

export interface OnboardingStatusResponse {
  ok: boolean
  report: HealthReportResponse
  recommendedFramework: 'claude' | 'cursor' | 'codex'
  hasSessions: boolean
  hasEvents: boolean
}

export interface FrameworkPreflightResponse {
  ok: boolean
  result: {
    ok: boolean
    framework: 'claude' | 'cursor' | 'codex'
    command: string
    details: string
  }
}

export function createHealthAPI(apiUrl: string) {
  return {
    async getHealthChecks(): Promise<HealthReportResponse | null> {
      try {
        const res = await fetch(`${apiUrl}/health/checks`)
        return await res.json()
      } catch {
        return null
      }
    },

    async applyFix(action: string): Promise<{ ok: boolean; message?: string; error?: string }> {
      try {
        const res = await fetch(`${apiUrl}/health/fix`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action }),
        })
        return await res.json()
      } catch {
        return { ok: false, error: 'Network error' }
      }
    },

    async getOnboardingStatus(): Promise<OnboardingStatusResponse | null> {
      try {
        const res = await fetch(`${apiUrl}/onboarding/status`)
        return await res.json()
      } catch {
        return null
      }
    },

    async preflight(framework: 'claude' | 'cursor' | 'codex'): Promise<FrameworkPreflightResponse | null> {
      try {
        const res = await fetch(`${apiUrl}/frameworks/preflight?framework=${encodeURIComponent(framework)}`)
        return await res.json()
      } catch {
        return null
      }
    },
  }
}

export type HealthAPI = ReturnType<typeof createHealthAPI>
